<template>
  <div class="xc-transparent">
    <input
      type="file"
      class="xc-transparent-input"
      @change="upload"
      :accept="accept"
      :multiple="multiple"
      :capture="capture"
      :value="value"
    >
    <input
      :value="inputValue"
      :name="name"
      style="display:none;"
    >
    <slot name="input-before"></slot>
    <slot name="input">
      <!-- <a class="x-btn x-btn-default"><i class="fa fa-upload"></i> 图片上传</a> -->
      <button class="xc-btn xc-btn-upload">上传</button>
    </slot>
    <slot name="input-after"></slot>
  </div>
</template>

<script>
import uploadBySignature from '@/utils/upload-file';
import http from '@/utils/http';

export default {
  name: 'XcInputFile',
  props: {
    name: null,
    type: {
      default: 1,
    },
    tips: {
    },

    fileList: {
      default: () => {
        return [];
      },
    },

    // 是否多选
    multiple: {
      default: false,
    },

    // 上传文件的字段名
    fieldname: {
      default: 'files'
    },

    accept: {},

    // 捕获到系统默认的设备
    capture: {},

    // 上传数量 0、不限制
    limit: {
      type: Number,
      default: 0,
    },

    // 接口URL
    url: {
      default: '/upload'
    },

    // 返回值取的key(未实现)
    dataName: {
      default: 'file'
    },

    // 上传提示
    loading: {
      default: '上传中...'
    },
    // 上传模式：signature(OBS签名) / backend(后台直传)
    uploadMode: {
      type: String,
      default: 'signature'
    },

    // 上传前
    beforeUpload: {
      type: Function,
      default: () => {
        console.log('beforeUpload');
      }
    },

    // 上传过程中
    uploadProgress: {
      type: Function,
      default: () => {

      }
    },
    // 上传成功
    uploadSuccess: {
      type: Function,
      default: () => {
      }
    },
  },
  components: {
  },
  data() {
    return {
      error: null,
      //   loading: false,
      value: null,
      index: 0,
    }
  },
  created() {
    console.log(this.$props);
  },
  computed: {
    files() {
      return this.fileList || [];
    },
    inputValue() {
      return (this.fileList || []).map(v => {
        return v[this.dataName]
      }).join(',');
    }
  },
  methods: {
    async sendByBackend(file, index) {
      const formData = new FormData();
      formData.append(this.fieldname || 'files', file);

      const ret = await http.post(this.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        showLoading: this.loading,
        onUploadProgress: (progressEvent) => {
          if (!progressEvent || !progressEvent.total) return;
          const percentage = (progressEvent.loaded / progressEvent.total * 100).toFixed(2);
          this.updateFiles(index, {
            percentage: percentage > 99 ? 99 : percentage,
            status: 'uploading',
          });
          this.uploadProgress && this.uploadProgress(progressEvent);
        },
      });

      const raw = ret && ret.data;
      if (Array.isArray(raw)) return raw[0] || {};
      if (raw && typeof raw === 'object') return raw;
      return {
        [this.dataName]: raw,
      };
    },

    async send(file) {

      // 上传前
      if (this.beforeUpload) {
        var result = this.beforeUpload(file);

        if (result == false) return;
      }

      //   let config = {
      //     headers: { 'Content-Type': 'multipart/form-data' },
      //     showLoading: '上传中...',
      //   };

      const returnFile = {
        index: this.index++,
        status: 'ready',
        name: file.name,
        size: file.size,
        percentage: 0,
        file: window.URL.createObjectURL(file),
      }

      // 支持文件多选
      if (this.multiple) {
        const data = this.fileList;
        data.push(returnFile);
        this.$emit('update:fileList', data)
      } else {
        this.$emit('update:fileList', [returnFile])
      }

      const index = this.fileList && this.fileList.length ? this.fileList.length - 1 : 0;

      const uploadPromise = this.uploadMode === 'backend'
        ? this.sendByBackend(file, index)
        : uploadBySignature(file, {
          onProgress: (progressEvent) => {
            const percentage = (progressEvent.loaded / progressEvent.total * 100).toFixed(2);

            this.updateFiles(index, {
              percentage: percentage > 99 ? 99 : percentage,
              status: 'uploading',
            })

            this.uploadProgress && this.uploadProgress(progressEvent);
          },
        });

      uploadPromise.then((ret) => {
        this.updateFiles(index, {
          ...ret,
          percentage: 100,
          status: 'success',
        })

        // 上传完成
        this.uploadSuccess && this.uploadSuccess({ data: [ret] });
      }).catch(error => {
        const msg = (Array.isArray(error) && error[0]) || (error && error.message) || '上传失败';
        if (this.$message) this.$message.error(msg);
        this.updateFiles(index, {
          status: 'fail',
          error: error,
          percentage: 100,
        })
      })
    },

    upload(e) {

      // 解决连续选择同一个文件
      this.value = null;

      const files = e.target.files;
      const { limit } = this;

      if (limit && (files.length + this.fileList.length) > limit) {
        return this.$message.error(`最多上传${limit}个文件`);
      }

      for (let i = 0; i < files.length; i++) {
        this.send(files[i]);
      }

    },

    updateFiles(index, data) {
      const fileList = [...this.fileList];
      fileList[index] = {
        ...this.fileList[index],
        ...data,
      }


      this.$emit('update:fileList', fileList)
    },

  }
}
</script>

<style scoped lang="scss">
</style>

